import React from 'react'

const SearchBar = () => {
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="row gy-12 gx-12 align-items-center">
                            <div className="col-sm-2">
                                <label className="visually-hidden" htmlFor="autoSizingInput">
                                    Name
                                </label>
                                Search Reports
                            </div>
                            <div className="col-sm-6">
                                <label className="visually-hidden" htmlFor="autoSizingInputGroup">
                                    Username
                                </label>
                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="autoSizingInputGroup"
                                        placeholder="Enter Reports Name etc"
                                    />
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <button
                                    type="button"
                                    className="btn btn-success waves-effect btn-label waves-light"
                                    style={{
                                        backgroundImage: "linear-gradient(90deg, #0ddcef, #319bfc)"
                                    }}
                                >
                                    <i className="bx bx-check-double label-icon" /> Search
                                </button>
                                &nbsp;{" "}
                                <button type="button" className="btn btn-outline-danger">
                                    Reset
                                </button>
                            </div>
                        </form>
                    </div>
                    {/* end card body */}
                </div>
                {/* end card */}
            </div>
            {/* end col */}
        </div>

    )
}

export default SearchBar